export enum KYC_STATUS {
  PendingReview = 'pending',
  PriorityReview = 'priority-review',
  RiskReview = 'fraud-review',
  ComplianceReview = 'compliance-review',
  RiskAndComplianceReview = 'fraud-review-compliance-review',
  Approved = 'approved',
  Declined = 'declined',
  VeriffBanned = 'veriff-banned',
  MaxKYCAttempts = 'max-kyc-attempts',
}
